// The firm's logo wherever the portal says whose office this is; the
// site's mark until the firm has both a name and a logo.

import { useState } from "react";
import { firmLogoSrc } from "../../api/attorneyConfig";
import { Mark } from "../chrome/Mark";

export function FirmMark({
  firmName,
  logoVersion,
  size,
}: {
  firmName: string | null | undefined;
  logoVersion: string | null | undefined;
  size: number;
}) {
  const [broken, setBroken] = useState<string | null>(null);
  // The logo stands beside the firm's name only: beside the product's word
  // it would name the wrong thing.
  const src = firmName ? firmLogoSrc(logoVersion) : null;
  // Empty alt: the name beside it says whose it is, as the mark's word does.
  return src && src !== broken ? (
    <img
      className="portal-logo"
      src={src}
      alt=""
      width={size}
      height={size}
      onError={() => setBroken(src)}
    />
  ) : (
    <Mark size={size} />
  );
}
